import { WRONG, CORRECT, MISSING, WAITING_FOR_CORRECTION, INCOMPLETE } from './exercise';

export const getCorrection = (results = []) => {
    const correctExercises = results.filter((item) => item === CORRECT);
    const wrongExercises = results.filter((item) => item === WRONG);
    const missingExercises = results.filter((item) => item === MISSING);
    const waitingCorrectionExercises = results.filter((item) => item === WAITING_FOR_CORRECTION);
    const incompleteCorrectionExercises = results.filter((item) => item === INCOMPLETE);
    return {
        [CORRECT]: correctExercises.length,
        [WRONG]: wrongExercises.length,
        [MISSING]: missingExercises.length,
        [WAITING_FOR_CORRECTION]: waitingCorrectionExercises.length,
        [INCOMPLETE]: incompleteCorrectionExercises.length,
    };
};

export const getUnitutorTotalScore = (correctionPoints, scoreModifier) =>
    correctionPoints.reduce((accumulator, correction) => {
        switch (correction.status) {
            case CORRECT:
                return accumulator + scoreModifier.correct;
            case WRONG:
                return accumulator + scoreModifier.wrong;
            case MISSING:
            default:
                return accumulator + scoreModifier.missing;
        }
    }, 0.0);
